import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { useIntl } from "gatsby-plugin-intl"

const Alumni = () => {
  const intl = useIntl()

  const data = useStaticQuery(graphql`
    query {
      fb: file(relativePath: { eq: "facebook.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      success: file(relativePath: { eq: "success.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      quotation: file(relativePath: { eq: "quotation.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO title="Alumni" />
      <div className="f-alumni__cover">
        <h1>{intl.formatMessage({ id: "ALUMNI.TITLE" })}</h1>
        <p>{intl.formatMessage({ id: "ALUMNI.SUBTITLE" })}</p>
      </div>
      <div className="f-alumni__join">
        <Img fluid={data.fb.childImageSharp.fluid} style={{ width: "100px" }} />
        <button>{intl.formatMessage({ id: "ALUMNI.BUTTON_JOIN" })}</button>
        <Img
          fluid={data.success.childImageSharp.fluid}
          style={{ width: "100px" }}
        />
      </div>
      <div className="f-alumni__description">
        <div>
          <h2>{intl.formatMessage({ id: "ALUMNI.TITLE_EXCLUSIVE" })}</h2>
          <p>{intl.formatMessage({ id: "ALUMNI.DESCRIPTION_EXCLUSIVE" })}</p>
        </div>
        <div>
          <h2>{intl.formatMessage({ id: "ALUMNI.TITLE_ADHERE" })}</h2>
          <p>{intl.formatMessage({ id: "ALUMNI.DESCRIPTION_ADHERE" })}</p>
        </div>
      </div>
      <div className="f-alumni__library"></div>
      <div className="f-alumni__quotation">
        <div className="f-alumni__quotation__quote">
          <div style={{ width: "100px" }}>
            <Img
              fluid={data.quotation.childImageSharp.fluid}
              style={{ width: "100%", minWidth: "50px" }}
            />
          </div>

          <p>
            {intl.formatMessage({ id: "ALUMNI.QUOTE" })} <br />
            <span style={{ fontSize: "14px" }}> - alumni Caroline</span>
          </p>
        </div>
        <hr />
        <Link to="/contact" className="f-button">
          {intl.formatMessage({ id: "ALUMNI.BUTTON_CONTACT" })}
        </Link>
      </div>
    </Layout>
  )
}

export default Alumni
